import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { throttleTime } from "rxjs/operators";
import { LogService } from 'src/app/services/log/log.service';

@Directive({ selector: '[click]' })
export class ClickDirective implements OnInit, OnDestroy {

  @Input() throttleTime = 500;
  @Input() elementName = '';
  @Output() throttledClick = new EventEmitter();

  private clicks = new Subject();
  private clickSubscription: Subscription | undefined;

  constructor(private logService: LogService) { }

  ngOnInit(): void {
    this.clickSubscription = this.clicks.pipe(
      throttleTime(this.throttleTime)
    ).subscribe(($event: Event) => {
      this.onClickLogging($event);
    })
  }

  ngOnDestroy(): void {
    if (this.clickSubscription !== undefined) {
      this.clickSubscription.unsubscribe();
    }
  }

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    this.clicks.next(event);
  }

  private onClickLogging($event: any): void {
    const domPath: string[] = [];
    if (Array.isArray($event.path)) {
      $event.path.forEach((path, index) => {
        const { localName } = path;
        if (index === 0) {
          domPath.push(localName);
          return;
        }
        // remove ionic tag, angular material tag, basic tags
        if (localName !== undefined && !/^(ion-|mat-|body|html|main|form|slot|div|app-root)/.test(localName)) {
          domPath.push(localName);
        }
      });
    }
    const className = $event?.target?.className;
    const elemName = ((domPath[1] ? `${domPath[1]}_` : '') + (this.elementName ?? className)).replace(/-/gi,'_');
    this.logService.clickLogging({
      elementName: elemName.endsWith('_') ? elemName.substring(0, elemName.length - 1) : elemName,
      clickElemClassName: className,
      clickElemPath: domPath.join(' < ')
    });
    this.throttledClick.emit($event);
  }
}